import { connect } from 'react-redux';
import { compose } from 'recompact';

import { errorBoundary } from 'src/app/hocs';
import type { RootState } from 'src/app/state/store';

import { UnconnectedErrorAlert } from '.';

function makeMapStateToProps() {
  return (state: RootState) => {
    return {
      customApi: state?.networkErrors?.customApi ?? null,
      genericError: state?.networkErrors?.genericApi ?? false,
      networkConnectivityError: state?.networkErrors?.networkConnectivityError ?? false,
    };
  };
}

export const ErrorAlert = compose(errorBoundary, connect(makeMapStateToProps))(UnconnectedErrorAlert);
ErrorAlert.displayName = 'ErrorAlert';
